import React, { useContext, useEffect, useRef, useState } from 'react';
import { FormHelperText, Grid, InputLabel, Paper, Tooltip, Typography } from '@material-ui/core';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';
import { TextBox as InputText } from '../../../../Core/FormInput';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import SignaturePad from 'react-signature-canvas';
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';
import { AppStorage } from '../../../../Core/Service/storage-service';

export const EditSInspectionSignOFF = (props) => {
    const context = useContext(InspectionCheCkContaxt) || {};

    const state = props.state || context.state || {};
    const setState = props.setState || context.setState;
    const portalSettings = props.portalSettings || context.portalSettings || {};
    const flags = props.flags || context.flags || {};
    const handleInput = props.handleInput || context.handleInput;
    const classes = props.classes || {};

    const signCanvasRef = useRef({});
    const containerRef = useRef(null);
    const [canvasWidth, setCanvasWidth] = useState(0);

    const isReadOnly = state.vehicleInspectionStatusID === 6;

    useEffect(() => {
        const updateWidth = () => {
            if (containerRef.current) {
                const w = containerRef.current.clientWidth || containerRef.current.offsetWidth;
                if (w > 0) {
                    setCanvasWidth(w);
                }
            }
        };

        updateWidth();
        const timer = setTimeout(updateWidth, 150);
        window.addEventListener('resize', updateWidth);

        return () => {
            clearTimeout(timer);
            window.removeEventListener('resize', updateWidth);
        };
    }, [state.signOffsignature]);

    const useDefaultSig = () => {
        if (props.useDefaultSig) {
            props.useDefaultSig();
        } else if (setState) {
            const sig = AppStorage.getSignature();
            setState((st) => ({
                ...st,
                img: true,
                vehicleInspectionSignedOffSignature: sig,
                signOffsignature: sig,
                errors: { ...st?.errors, vehicleInspectionSignedOffSignature: undefined }
            }));
        }
    };

    const clear = () => {
        if (props.clear) {
            props.clear();
        } else {
            if (signCanvasRef.current && typeof signCanvasRef.current.clear === 'function') {
                signCanvasRef.current.clear();
            }
            if (setState) {
                setState((st) => ({
                    ...st,
                    vehicleInspectionSignedOffSignature: null,
                    signOffsignature: null
                }));
            }
        }
    };

    const GetTechnicianSign = () => {
        if (props.GetTechnicianSign) {
            props.GetTechnicianSign();
        } else if (signCanvasRef.current && typeof signCanvasRef.current.toDataURL === 'function') {
            const sigUrl = signCanvasRef.current.toDataURL();
            if (setState) {
                setState((st) => ({
                    ...st,
                    vehicleInspectionSignedOffSignature: sigUrl,
                    errors: { ...st?.errors, vehicleInspectionSignedOffSignature: undefined }
                }));
            }
        }
    };

    let ManagerDeclaration = portalSettings.portalSettingSignOffManagerDeclaration?.replace('{eventname}', flags?.scheduleEventName);
    let OnHireDeclaration = portalSettings.portalSettingCustomerOnHireDeclaration?.replace('{eventname}', flags?.scheduleEventName);
    let OffHireDeclaration = portalSettings.portalSettingCustomerOffHireDeclaration?.replace('{eventname}', flags?.scheduleEventName);

    const signAvailable = AppStorage.getSignature() !== 'absent';
    const showSignBtn = !isReadOnly;

    return (
        <Grid container item xs={12}>
            {classes.sectionCard ? (
                <div className={classes.sectionCard} style={{ width: '100%', marginBottom: 14 }}>
                    <div className={classes.sectionHeader}>
                        <div className={classes.sectionTitleWrap}>
                            <span className={classes.sectionAccent} />
                            <h3 className={classes.sectionTitleText}>Sign Off</h3>
                        </div>
                    </div>

                    <div style={{ padding: '14px 18px' }}>
                        {flags.displayCustomerDeclaration === 0 ? (
                            <Grid item xs={12}>
                                {ManagerDeclaration && (
                                    <div
                                        style={{
                                            color: '#64748b',
                                            fontSize: 12,
                                            marginBottom: 14,
                                            lineHeight: 1.5
                                        }}
                                        dangerouslySetInnerHTML={{ __html: ManagerDeclaration }}
                                    />
                                )}
                                <Grid container spacing={2} justify="space-between">
                                    <Grid item xs={12} lg={6}>
                                        <InputLabel shrink className={classes.fieldLabel} style={{ marginBottom: 4 }}>
                                            Comment
                                        </InputLabel>
                                        {state.vehicleInspectionStatusID === 2 ? (
                                            <Typography variant="h6">{state.vehicleInspectionSignedOffComment}</Typography>
                                        ) : (
                                            <InputText
                                                multiline
                                                rows={4}
                                                placeholder="Comment"
                                                name="vehicleInspectionSignedOffComment"
                                                value={state.vehicleInspectionSignedOffComment || ''}
                                                onChange={handleInput}
                                                // disabled={isReadOnly}
                                                fullWidth
                                                InputProps={{
                                                    style: {
                                                        height: 125,
                                                        alignItems: 'flex-start',
                                                        backgroundColor: '#fff'
                                                    }
                                                }}
                                                inputProps={{
                                                    style: {
                                                        height: '100%',
                                                        boxSizing: 'border-box'
                                                    }
                                                }}
                                                style={{ height: 125, margin: 0 }}
                                            />
                                        )}
                                        <FormHelperText error>{state.errors?.vehicleInspectionSignedOffComment}</FormHelperText>
                                    </Grid>

                                    <Grid item xs={12} lg={6}>
                                        <div style={{ position: 'relative' }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: -3 }}>
                                                <InputLabel shrink className={classes.fieldLabel} style={{ margin: 0 }}>
                                                    Signature{' '}
                                                    {showSignBtn && (
                                                        <Tooltip title="Use default signature">
                                                            <BorderColorIcon
                                                                onClick={useDefaultSig}
                                                                style={{ cursor: 'pointer', verticalAlign: 'middle', marginLeft: 6, fontSize: 16 }}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </InputLabel>
                                                {!isReadOnly && (
                                                    <Tooltip title="Clear Signature">
                                                        <DeleteIcon
                                                            onClick={clear}
                                                            style={{
                                                                cursor: 'pointer',
                                                                color: '#f50057',
                                                                fontSize: 18
                                                            }}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </div>

                                            {state.vehicleInspectionStatusID === 4 && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        bottom: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    <Typography variant="body1">{state.vehicleInspectionSignedOffName}</Typography>
                                                    <Typography variant="button">
                                                        {moment(state.vehicleInspectionSignedOffDate).format('DD/MM/YYYY HH:mm')}
                                                    </Typography>
                                                </div>
                                            )}

                                            {state.signOffsignature ? (
                                                <div
                                                    style={{
                                                        border: '1px solid #ced4da',
                                                        borderRadius: 4,
                                                        background: '#fafafa',
                                                        padding: 4,
                                                        height: 125,
                                                        boxSizing: 'border-box',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <img
                                                        src={state.signOffsignature}
                                                        alt="Signature"
                                                        style={{
                                                            display: 'block',
                                                            maxHeight: 115,
                                                            maxWidth: '100%',
                                                            objectFit: 'contain'
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    ref={containerRef}
                                                    style={{
                                                        border: '1px solid #ced4da',
                                                        borderRadius: 4,
                                                        background: '#ffffff',
                                                        height: 125,
                                                        boxSizing: 'border-box',
                                                        overflow: 'hidden',
                                                        width: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    {canvasWidth > 0 ? (
                                                        <SignaturePad
                                                            ref={signCanvasRef}
                                                            canvasProps={{
                                                                width: canvasWidth,
                                                                height: 123,
                                                                style: {
                                                                    width: `${canvasWidth}px`,
                                                                    height: '123px',
                                                                    display: 'block',
                                                                    cursor: 'crosshair',
                                                                    backgroundColor: '#ffffff'
                                                                }
                                                            }}
                                                            onEnd={GetTechnicianSign}
                                                        />
                                                    ) : (
                                                        <SignaturePad
                                                            ref={signCanvasRef}
                                                            canvasProps={{
                                                                height: 123,
                                                                style: {
                                                                    width: '100%',
                                                                    height: '123px',
                                                                    display: 'block',
                                                                    cursor: 'crosshair',
                                                                    backgroundColor: '#ffffff'
                                                                }
                                                            }}
                                                            onEnd={GetTechnicianSign}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                            <FormHelperText error>{state.errors?.vehicleInspectionSignedOffSignature}</FormHelperText>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Grid container spacing={2} justify="space-between" alignItems="flex-end">
                                    <Grid item xs={12}>
                                        {flags.displayCustomerDeclaration === 1 && OnHireDeclaration && (
                                            <div
                                                style={{ color: '#64748b', fontSize: 12, marginBottom: 14, lineHeight: 1.5 }}
                                                dangerouslySetInnerHTML={{ __html: OnHireDeclaration }}
                                            />
                                        )}
                                        {flags.displayCustomerDeclaration === 2 && OffHireDeclaration && (
                                            <div
                                                style={{ color: '#64748b', fontSize: 12, marginBottom: 14, lineHeight: 1.5 }}
                                                dangerouslySetInnerHTML={{ __html: OffHireDeclaration }}
                                            />
                                        )}
                                    </Grid>
                                    <Grid item container spacing={1} xs={12} lg={6}>
                                        <Grid item xs={12} style={{ marginTop: 5 }}>
                                            <InputLabel shrink className={classes.fieldLabel}>
                                                Comment
                                            </InputLabel>
                                            <InputText
                                                multiline
                                                rows={4}
                                                placeholder="Comment"
                                                name="vehicleInspectionSignedOffComment"
                                                value={state.vehicleInspectionSignedOffComment || ''}
                                                onChange={handleInput}
                                                disabled={isReadOnly}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={6}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    border: '1px solid rgba(0,0,0,0.2)',
                                                    marginTop: 6,
                                                    padding: 4,
                                                    borderRadius: 4
                                                }}
                                            >
                                                <Typography variant="body1">{state.vehicleDailyCheckCheckerName}</Typography>
                                                <Typography variant="button">
                                                    {moment(state.vehicleInspectionDateInspected).format('DD/MM/YYYY HH:mm')}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <InputLabel shrink error={Boolean(state.errors?.vehicleInspectionSignedOffName)}>
                                                Customer Name
                                            </InputLabel>
                                            <InputText
                                                placeholder="Customer Name"
                                                name="vehicleInspectionSignedOffName"
                                                onChange={handleInput}
                                                value={state.vehicleInspectionSignedOffName || ''}
                                                disabled={isReadOnly}
                                                fullWidth
                                            />
                                            <FormHelperText error>{state.errors?.vehicleInspectionSignedOffName}</FormHelperText>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12} lg={6}>
                                        <div style={{ position: 'relative' }}>
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    marginBottom: state.signOffsignature ? 2 : -3
                                                }}
                                            >
                                                <InputLabel shrink className={classes.fieldLabel} style={{ margin: 0 }}>
                                                    Signature{' '}
                                                    {showSignBtn && (
                                                        <Tooltip title="Use default signature">
                                                            <BorderColorIcon
                                                                onClick={useDefaultSig}
                                                                style={{ cursor: 'pointer', verticalAlign: 'middle', marginLeft: 6, fontSize: 16 }}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                </InputLabel>
                                                {!isReadOnly && (
                                                    <Tooltip title="Clear Signature">
                                                        <DeleteIcon
                                                            onClick={clear}
                                                            style={{
                                                                cursor: 'pointer',
                                                                color: '#f50057',
                                                                fontSize: 18
                                                            }}
                                                        />
                                                    </Tooltip>
                                                )}
                                            </div>

                                            {state.vehicleInspectionStatusID === 4 && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        bottom: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end',
                                                        zIndex: 2
                                                    }}
                                                >
                                                    <Typography variant="body1">{state.vehicleInspectionSignedOffName}</Typography>
                                                    <Typography variant="button">
                                                        {moment(state.vehicleInspectionSignedOffDate).format('DD/MM/YYYY HH:mm')}
                                                    </Typography>
                                                </div>
                                            )}

                                            {state.signOffsignature ? (
                                                <div
                                                    style={{
                                                        border: '1px solid #ced4da',
                                                        borderRadius: 4,
                                                        background: '#fafafa',
                                                        padding: 4,
                                                        height: 125,
                                                        boxSizing: 'border-box',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <img
                                                        src={state.signOffsignature}
                                                        alt="Signature"
                                                        style={{
                                                            display: 'block',
                                                            maxHeight: 115,
                                                            maxWidth: '100%',
                                                            objectFit: 'contain'
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    ref={containerRef}
                                                    style={{
                                                        border: '1px solid #ced4da',
                                                        borderRadius: 4,
                                                        background: '#ffffff',
                                                        height: 125,
                                                        boxSizing: 'border-box',
                                                        overflow: 'hidden',
                                                        width: '100%',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    {canvasWidth > 0 ? (
                                                        <SignaturePad
                                                            ref={signCanvasRef}
                                                            canvasProps={{
                                                                width: canvasWidth,
                                                                height: 123,
                                                                style: {
                                                                    width: `${canvasWidth}px`,
                                                                    height: '123px',
                                                                    display: 'block',
                                                                    cursor: 'crosshair',
                                                                    backgroundColor: '#ffffff'
                                                                }
                                                            }}
                                                            onEnd={GetTechnicianSign}
                                                        />
                                                    ) : (
                                                        <SignaturePad
                                                            ref={signCanvasRef}
                                                            canvasProps={{
                                                                height: 123,
                                                                style: {
                                                                    width: '100%',
                                                                    height: '123px',
                                                                    display: 'block',
                                                                    cursor: 'crosshair',
                                                                    backgroundColor: '#ffffff'
                                                                }
                                                            }}
                                                            onEnd={GetTechnicianSign}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                            <FormHelperText error>{state.errors?.vehicleInspectionSignedOffSignature}</FormHelperText>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        )}
                    </div>
                </div>
            ) : (
                <Paper className={classes.paper} style={{ width: '100%' }}>
                    {flags.displayCustomerDeclaration === 0 ? (
                        <Grid item xs={12}>
                            <Grid container xs={12}>
                                <h3 className={classes.headings}>Sign Off</h3>
                            </Grid>
                            <Grid container spacing={1} justify="space-between">
                                <Grid item xs={12} sm={12} className="mandatory-fields">
                                    <div
                                        className={classes.headings}
                                        style={{ marginTop: -30 }}
                                        dangerouslySetInnerHTML={{
                                            __html: ManagerDeclaration
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6} style={{ marginTop: 9 }}>
                                    <InputLabel shrink>Comment</InputLabel>
                                    {state.vehicleInspectionStatusID === 2 ? (
                                        <Typography variant="h6">{state.vehicleInspectionSignedOffComment} </Typography>
                                    ) : (
                                        <InputText
                                            style={{ marginTop: 9 }}
                                            multiline
                                            rows={7}
                                            placeholder="Comment"
                                            name="vehicleInspectionSignedOffComment"
                                            value={state.vehicleInspectionSignedOffComment || ''}
                                            onChange={handleInput}
                                            disabled={isReadOnly}
                                        />
                                    )}
                                    <FormHelperText error>{state.errors?.vehicleInspectionSignedOffComment}</FormHelperText>
                                </Grid>
                                <Grid item spacing={2} xs={12} md={6}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <div style={{ position: 'relative' }}>
                                            <InputLabel shrink error={Boolean(state.errors?.vehicleInspectionSignedOffSignature)}>
                                                Signature
                                                {showSignBtn ? (
                                                    <Tooltip title="Use default signature">
                                                        <BorderColorIcon onClick={useDefaultSig} style={{ cursor: 'pointer', margin: '0px 0px -5px 5px' }} />
                                                    </Tooltip>
                                                ) : null}
                                            </InputLabel>
                                            {!isReadOnly && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        top: 40
                                                    }}
                                                >
                                                    <Tooltip title="Clear Signature">
                                                        <DeleteIcon
                                                            onClick={clear}
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            )}
                                            {state.vehicleInspectionStatusID === 4 ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        bottom: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end'
                                                    }}
                                                >
                                                    <Typography variant="body1">{state.vehicleInspectionSignedOffName}</Typography>
                                                    <Typography variant="button">
                                                        {moment(state.vehicleInspectionSignedOffDate).format('DD/MM/YYYY HH:mm')}
                                                    </Typography>
                                                </div>
                                            ) : null}
                                            <div className="workflow-job-details">
                                                {state.signOffsignature ? (
                                                    <div className="sigContainer">
                                                        <img src={state.signOffsignature} style={{ width: '100%', height: '100%' }} alt="my signature" />
                                                    </div>
                                                ) : (
                                                    <div className="sigContainer">
                                                        <SignaturePad ref={signCanvasRef} canvasProps={{ className: 'sigPad' }} onEnd={GetTechnicianSign} />
                                                    </div>
                                                )}
                                            </div>
                                            <FormHelperText error>{state.errors?.vehicleInspectionSignedOffSignature}</FormHelperText>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container xs={12}>
                                <h5 className={classes.headings}>&nbsp;</h5>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <Grid container xs={12}>
                                <h3 className={classes.headings}>Sign Off</h3>
                            </Grid>
                            <Grid container spacing={1} justify="space-between" alignItems="flex-end">
                                <Grid item xs={12}>
                                    {flags.displayCustomerDeclaration === 1 && (
                                        <div style={{ marginTop: -20 }} className={classes.headings} dangerouslySetInnerHTML={{ __html: OnHireDeclaration }} />
                                    )}
                                    {flags.displayCustomerDeclaration === 2 && (
                                        <div style={{ marginTop: -20 }} className={classes.headings} dangerouslySetInnerHTML={{ __html: OffHireDeclaration }} />
                                    )}
                                </Grid>
                                <Grid item container spacing={1} xs={12} md={6}>
                                    <Grid item xs={12} md={12} lg={12} style={{ marginTop: 5 }}>
                                        <InputLabel shrink> Comment</InputLabel>
                                        <InputText
                                            multiline
                                            rows={4}
                                            placeholder="comment"
                                            name="vehicleInspectionSignedOffComment"
                                            value={state.vehicleInspectionSignedOffComment || ''}
                                            onChange={handleInput}
                                            disabled={isReadOnly}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <div
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                border: '1px solid rgba(0,0,0,0.2)',
                                                marginTop: 6
                                            }}
                                        >
                                            <Typography variant="body1">{state.vehicleDailyCheckCheckerName}</Typography>
                                            <Typography variant="button">{moment(state.vehicleInspectionDateInspected).format('DD/MM/YYYY HH:mm')}</Typography>
                                        </div>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <InputLabel shrink error={Boolean(state.errors?.vehicleInspectionSignedOffName)}>
                                            Customer Name
                                        </InputLabel>
                                        <InputText
                                            placeholder="Customer Name"
                                            name="vehicleInspectionSignedOffName"
                                            onChange={handleInput}
                                            value={state.vehicleInspectionSignedOffName || ''}
                                            disabled={isReadOnly}
                                        />
                                        <FormHelperText error>{state.errors?.vehicleInspectionSignedOffName}</FormHelperText>
                                    </Grid>
                                </Grid>
                                <Grid item spacing={2} xs={12} md={6}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <div style={{ position: 'relative' }}>
                                            <InputLabel shrink error={Boolean(state.errors?.vehicleInspectionSignedOffSignature)}>
                                                Signature
                                                {showSignBtn ? (
                                                    <Tooltip title="Use default signature">
                                                        <BorderColorIcon onClick={useDefaultSig} style={{ cursor: 'pointer', margin: '0px 0px -5px 5px' }} />
                                                    </Tooltip>
                                                ) : null}
                                            </InputLabel>
                                            {!isReadOnly && (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 0
                                                    }}
                                                >
                                                    <Tooltip title="Clear Signature">
                                                        <DeleteIcon
                                                            onClick={clear}
                                                            style={{
                                                                cursor: 'pointer'
                                                            }}
                                                        />
                                                    </Tooltip>
                                                </div>
                                            )}
                                            {state.vehicleInspectionStatusID === 4 ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        bottom: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end'
                                                    }}
                                                >
                                                    <Typography variant="body1">{state.vehicleInspectionSignedOffName}</Typography>
                                                    <Typography variant="button">
                                                        {moment(state.vehicleInspectionSignedOffDate).format('DD/MM/YYYY HH:mm')}
                                                    </Typography>
                                                </div>
                                            ) : null}
                                            <div className="workflow-job-details">
                                                {state.signOffsignature ? (
                                                    <div className="sigContainer">
                                                        <div className="sigPad">
                                                            <img src={state.signOffsignature} style={{ width: '100%', height: '100%' }} alt="my signature" />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="sigContainer">
                                                        <SignaturePad ref={signCanvasRef} canvasProps={{ className: 'sigPad' }} onEnd={GetTechnicianSign} />
                                                    </div>
                                                )}
                                            </div>
                                            <FormHelperText error>{state.errors?.vehicleInspectionSignedOffSignature}</FormHelperText>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container xs={12}>
                                <h5 className={classes.headings}>&nbsp;</h5>
                            </Grid>
                        </Grid>
                    )}
                </Paper>
            )}
        </Grid>
    );
};

export default EditSInspectionSignOFF;
